import script from "./addNewRequire.vue?vue&type=script&setup=true&lang=js"
export * from "./addNewRequire.vue?vue&type=script&setup=true&lang=js"

import "./addNewRequire.vue?vue&type=style&index=0&id=c602dd9e&lang=scss&scoped=true"
import "./addNewRequire.vue?vue&type=style&index=1&id=c602dd9e&lang=css"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c602dd9e"]])

export default __exports__